import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { InvalidOperationError } from "../common/Error";
import { DialogServiceTurnState } from "./DialogServiceTurnState";
export var DialogServiceTurnStateManager = /*#__PURE__*/function () {
  function DialogServiceTurnStateManager() {
    _classCallCheck(this, DialogServiceTurnStateManager);

    this.privTurnMap = new Map();
    return;
  }

  _createClass(DialogServiceTurnStateManager, [{
    key: "StartTurn",
    value: function StartTurn(id) {
      if (this.privTurnMap.has(id)) {
        throw new InvalidOperationError("Service error: There is already a turn with id:" + id);
      }

      var turnState = new DialogServiceTurnState(this, id);
      this.privTurnMap.set(id, turnState);
      return this.privTurnMap.get(id);
    }
  }, {
    key: "GetTurn",
    value: function GetTurn(id) {
      return this.privTurnMap.get(id);
    }
  }, {
    key: "CompleteTurn",
    value: function CompleteTurn(id) {
      if (!this.privTurnMap.has(id)) {
        throw new InvalidOperationError("Service error: Received turn end for an unknown turn id:" + id);
      }

      var turnState = this.privTurnMap.get(id);
      turnState.complete();
      this.privTurnMap.delete(id);
      return turnState;
    }
  }]);

  return DialogServiceTurnStateManager;
}();